import { render, staticRenderFns } from "./SupplierProductAdd.vue?vue&type=template&id=1a23514a&scoped=true"
import script from "./SupplierProductAdd.vue?vue&type=script&lang=ts"
export * from "./SupplierProductAdd.vue?vue&type=script&lang=ts"
import style0 from "./SupplierProductAdd.vue?vue&type=style&index=0&id=1a23514a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a23514a",
  null
  
)

export default component.exports